<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalPendiente: 0,
        totalPagado: 0,
        vendedor: "",
        total: "",
        state: true,
        id: 0,
      },
      estadoCredito: false,
      formFactura: {
        fecha_emision: "",
        fecha_certificacion: "",
        dataCert: "",
        serie: "",
        number: "",
        uuid: "",
      },
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
      detalleProducto : [],
      detalleServicio :[],
        arqueo :{},
        creditos : [],
        creditosTaller:[]
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  updated() {
    this.$refs["buttonImprimir"].click();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    formatQuetzales (amount) {
        let num = parseFloat(amount), formatted
        formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        return amount = 'Q ' + formatted
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
    //   let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "caja/recibo?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
        console.log(response)
            this.arqueo = response.data.arqueo;
            this.creditos = response.data.creditos;
            this.creditosTaller = response.data.creditosTaller;
 
        
        });
    },
    calcularTotal() {
      let total = 0;
      this.detalleServicio.forEach(item => {
        total += item.subtotal_servicio;
      });
      return this.money(total);
    },
    calcularTotalRepuestos() {
      let total = 0;
      this.detalleProducto.forEach(item => {
        total += item.subtotal_venta;
      });
      return this.money(total);
    },
    formatoPresentacion(date){
        return moment(date).locale('es').format('LL'); 
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  },
};
</script>
<style></style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mt-4">
      <div class="col d-print-none">
        <router-link
          :to="{
            name: 'inicioCaja',
          }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col d-print-none">
        <div class="float-end">
          <a
            ref="buttonImprimir"
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
            ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a
          >
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <img
                  class="img-fluid float-right"
                  src="../../../../../src/assets/mecanica1.jpg"
                  alt="Logo"
                  width="300" height="100"
                />
              </div>
              <div class="col">
                <h6>Taller de REPARACIÓN ARIEL</h6>
                <label
                  ><i class="bx bx-phone"></i>42837238</label
                ><br />
                <label
                  ><i class="bx bx-map"></i> Compa Jutiapa<br /> </label
                ><br />
                <h4>
                <br>
                            <h4><strong>REPORTE ARQUEO DE CAJA DE {{arqueo.user.usuario}}</strong></h4>
                            <br>
                            <label
                              ><i class="bx bx-map"></i>Observaciones: {{arqueo.observacion}} <br />
                              {{this.formatoPresentacion(arqueo.fecha_registrada)}}
                              </label
                            >
                            <br>
                </h4>
              </div>
            </div>
            <br />
            <table class="table" border="2">
                            <thead>
                              <tr>
                                <th>
                                  <i class="bx bxs-grid-alt"></i
                                  >&nbsp;&nbsp;Descripción
                                </th>
                                <th>
                                  <i class="bx bx-list-ul"></i
                                  >&nbsp;&nbsp;Monto
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                        <tr >
                            <td>Monto inicial caja</td>
                            <td>{{formatQuetzales(arqueo.inicio_caja)}} </td>
                        </tr>
                        <tr >
                            <td>Monto de ventas del día de hoy (solo ventas registradas por el sistema, sin créditos)</td>
                            <td>{{formatQuetzales(arqueo.fin_sistema)}}</td>
                        </tr>
                        <tr >
                            <td>Total créditos pagados adjuntados a caja</td>
                            <td>{{formatQuetzales(arqueo.fin_abonos)}}</td>
                        </tr>
                        <tr >
                            <td><strong>TOTAL DINERO</strong></td>
                            <td><strong>{{formatQuetzales(parseFloat(arqueo.inicio_caja) + parseFloat(arqueo.fin_sistema) +parseFloat(arqueo.fin_abonos) + parseFloat(arqueo.fin_abonos_taller == null ? 0 : arqueo.fin_abonos_taller ))}} </strong> </td>
                        </tr>
                  
                        <tr >
                    
                                <td>Total egresos</td>
                                <td>{{formatQuetzales(arqueo.fin_egresos)}}</td>
                        </tr>
                        <tr >
                            <td><strong>TOTAL DINERO MENOS EGRESOS</strong></td>
                            <td> <strong>{{formatQuetzales((parseFloat(arqueo.inicio_caja) +parseFloat(arqueo.fin_sistema) +parseFloat(arqueo.fin_abonos) + parseFloat(arqueo.fin_abonos_taller == null ? 0 : arqueo.fin_abonos_taller ))-parseFloat(arqueo.fin_egresos)  )}} </strong> </td>
                        </tr>
                    </tbody>
            </table>
            <br>
                            <h4><strong>RESUMEN DE DEPOSITOS</strong></h4>
                            <br>
                          <table class="table" border="2">
                            <thead>
                              <tr>
                                <th>
                                  <i class="bx bxs-grid-alt"></i
                                  >&nbsp;&nbsp;Descripción
                                </th>
                                <th>
                                  <i class="bx bx-list-ul"></i
                                  >&nbsp;&nbsp;Monto
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                                <tr id="de">
                                    <td>No. Deposito {{arqueo.no_deposito}}</td>
                                    <td>{{formatQuetzales(arqueo.monto_deposito == null ? 0 :arqueo.monto_deposito)}}</td>
                                </tr>
                            </tbody>
                            
                          </table>
                          <br>
                            <h4><strong>RESUMEN DE EGRESOS</strong></h4>
                            <br>
                          <table class="table" border="2">
                            <thead>
                              <tr>
                                <th>
                                  <i class="bx bxs-grid-alt"></i
                                  >&nbsp;&nbsp;Descripción
                                </th>
                                <th>
                                  <i class="bx bxs-grid-alt"></i
                                  >&nbsp;&nbsp;Usuario
                                </th>
                                <th>
                                  <i class="bx bx-list-ul"></i
                                  >&nbsp;&nbsp;Monto
                                </th>
                              </tr>
                            </thead>
                            <tbody >
                                <tr id="de" v-for="(item, index) in arqueo.egresos" v-bind:key="index">
                                    <td>Razon:  {{item.razon}}</td>
                                    <td>Usuario:  {{item.user.usuario}}</td>
                                    <td>{{formatQuetzales(item.monto)}}</td>
                                </tr>
                            </tbody>
                            
                          </table>
                          <br>
                            <h4><strong>RESUMEN DE ABONO CRÉDITOS</strong></h4>
                            <br>
                          <table class="table" border="2">
                            <thead>
                              <tr>
                                <th>
                                  <i class="bx bxs-grid-alt"></i
                                  >&nbsp;&nbsp;No. venta  
                                </th>
                                <th>
                                  <i class="bx bxs-grid-alt"></i
                                  >&nbsp;&nbsp;Cliente
                                </th>
                                <th>
                                  <i class="bx bx-list-ul"></i
                                  >&nbsp;&nbsp;Fecha pago
                                </th>
                                <th>
                                  <i class="bx bx-list-ul"></i
                                  >&nbsp;&nbsp;Modo pago
                                </th>
                                <th>
                                  <i class="bx bx-list-ul"></i
                                  >&nbsp;&nbsp;Cantidad abonada
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr id="de" v-for="(item, index) in creditos" v-bind:key="index">
                                  <td>{{item.venta.no_ducumento_v}}</td>
                                  <td>{{item.venta.cliente.persona.nombre_persona + ' ' + item.venta.cliente.persona.apellido_persona  }}</td>
                                  <td>{{item.fecha_pago }}</td>
                                  <td>{{item.metodo_pago }}</td>
                                  <td>{{formatQuetzales(item.abono) }}</td>
                                  <!-- <td>Q </td> -->
                                  
                              </tr>
                                    
                              <tr id="#dee">
                                <th></th>
                                <th></th>
                                <th></th>
                                  <td><strong>TOTAL</strong></td>
                                  <td>{{formatQuetzales(arqueo.fin_abonos)  }}</td>
                              </tr>
                          </tbody>
                            
                          </table>
                          <br>
                            <h4><strong>RESUMEN DE ABONO CRÉDITOS TALLER</strong></h4>
                            <br>
                          <table class="table" border="2">
                            <thead>
                              <tr>
                                <th>
                                  <i class="bx bxs-grid-alt"></i
                                  >&nbsp;&nbsp;No. venta  
                                </th>
                                <th>
                                  <i class="bx bxs-grid-alt"></i
                                  >&nbsp;&nbsp;Cliente
                                </th>
                                <th>
                                  <i class="bx bx-list-ul"></i
                                  >&nbsp;&nbsp;Fecha pago
                                </th>
                                <th>
                                  <i class="bx bx-list-ul"></i
                                  >&nbsp;&nbsp;Modo pago
                                </th>
                                <th>
                                  <i class="bx bx-list-ul"></i
                                  >&nbsp;&nbsp;Cantidad abonada
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr id="de" v-for="(item, index) in creditosTaller" v-bind:key="index">
                                  <td>{{item.taller.no_servicio}}</td>
                                  <td>{{item.taller.vehiculo.cliente.persona.nombre_persona   }}</td>
                                  <td>{{item.fecha_pago }}</td>
                                  <td>{{item.metodo_pago }}</td>
                                  <td>{{formatQuetzales(item.abono) }}</td>
                                  <!-- <td>Q </td> -->
                                  
                              </tr>
                                    
                              <tr id="#dee">
                                <th></th>
                                <th></th>
                                <th></th>
                                  <td><strong>TOTAL</strong></td>
                                  <td>{{formatQuetzales(arqueo.fin_abonos_taller)  }}</td>
                              </tr>
                          </tbody>
                            
                          </table>
            
            <hr style="color: black" />
            <br>
                            <h4><strong>RESUMEN DE CAJAS</strong></h4>
                            <br>
                          <table class="table" border="2">
                                <thead>
                                  <tr>
                                    <th>
                                      <i class="bx bxs-grid-alt"></i
                                      >&nbsp;&nbsp;Descripción
                                    </th>
                                    <th>
                                      <i class="bx bx-list-ul"></i
                                      >&nbsp;&nbsp;Monto
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                            <tr >
                                <td>EL EMPLEADO REGISTRO EN EFECTIVO</td>
                                <td>{{formatQuetzales(arqueo.fin_caja)}} </td>
                            </tr>
                            <tr >
                                <td>El EMPLEADO REGISTRO EN DEPOSITOS</td>
                                <td>{{formatQuetzales(arqueo.monto_deposito == null ? 0 :arqueo.monto_deposito)}}</td>
                            </tr>
                            <tr >
                                <td>FIN TOTAL EMPLEADO</td>
                                <td>{{formatQuetzales(parseFloat((arqueo.monto_deposito == null ? 0 :arqueo.monto_deposito)) +parseFloat(( arqueo.fin_caja)))}}</td>
                            </tr>
                            <tr >
                                <td>TOTAL DINERO QUE DEBERIA HABER</td>
                                <td>{{formatQuetzales((parseFloat(arqueo.inicio_caja) +parseFloat(arqueo.fin_sistema) +parseFloat(arqueo.fin_abonos) + parseFloat(arqueo.fin_abonos_taller == null ? 0 : arqueo.fin_abonos_taller )
                                 - parseFloat(arqueo.fin_egresos)))}}</td>
                            </tr>
                            <tr >
                              <!-- <td>{{ ((arqueo.fin_caja +( arqueo.monto_deposito == null ? 0 :arqueo.monto_deposito) - (arqueo.inicio_caja + arqueo.fin_sistema + arqueo.fin_abonos) + (arqueo.fin_egresos)) > 0) ? 'Dinero que sobra' : 'Dinero extraviado' }}</td>
                              <td>Q {{ arqueo.fin_caja + (arqueo.monto_deposito == null ? 0 :arqueo.monto_deposito) - (arqueo.inicio_caja + arqueo.fin_sistema + arqueo.fin_abonos) - (arqueo.fin_egresos) }}</td> -->
                              <td>{{ ((( parseFloat(arqueo.fin_caja) +( arqueo.monto_deposito == null ? 0 :parseFloat(arqueo.monto_deposito))) - 
                              ((parseFloat(arqueo.inicio_caja) + parseFloat(arqueo.fin_sistema) + parseFloat(arqueo.fin_abonos) + parseFloat(arqueo.fin_abonos_taller == null ? 0 : arqueo.fin_abonos_taller )) - (parseFloat(arqueo.fin_egresos)))) > 0) ? 'Dinero que sobra' :
                              (((parseFloat(arqueo.fin_caja) +( arqueo.monto_deposito == null ? 0 : parseFloat(arqueo.monto_deposito))) - ((parseFloat(arqueo.inicio_caja) + 
                              parseFloat(arqueo.fin_sistema) + parseFloat(arqueo.fin_abonos)+parseFloat(arqueo.fin_abonos_taller == null ? 0 : arqueo.fin_abonos_taller )) - (parseFloat(arqueo.fin_egresos)))) == 0) ? 'Caja completa' : 
                              'Dinero extraviado' }}</td>
                              <td>Q {{ ( parseFloat(arqueo.fin_caja) + (arqueo.monto_deposito == null ? 0 : parseFloat(arqueo.monto_deposito))) -
                               ((parseFloat(arqueo.inicio_caja) + parseFloat(arqueo.fin_sistema) + parseFloat(arqueo.fin_abonos)+parseFloat(arqueo.fin_abonos_taller == null ? 0 : arqueo.fin_abonos_taller )) - (parseFloat(arqueo.fin_egresos)) )}}</td>
                            </tr>
                        </tbody>
                        </table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.fondo {
  background-color: #f05948;
}
/*
@media print {
  @page {
    margin: 10px;
    size: auto;
  }
}*/
</style>
